module.exports = __webpack_public_path__ + "smartphone.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/smartphone.svg
// module id = 1150
// module chunks = 10